import {initVlinkConnection} from './connection';
import './types';

initVlinkConnection();
